<script>
import Utility from '@/common/UtilityFunctions.js';
import Affix from '@/components/UI/Affix.vue';
import MediaQueriesMixin from '@/components/Mixins/MediaQueriesMixin';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  components: {
    Affix
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  mixins: [MediaQueriesMixin],
  props: {
    debugMode: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      // debugMode: true, // this will output details in console.log about states and behaviour // TODO: MAYH
      memberId: localStorage.getItem('logged_in_member')
    };
  },
  methods: {
    getForm() {
      return this.form || this.$refs.quickQuoteFlow || this.$refs.form;
    },
    scrollToFirstError() {
      if(!this.getForm())
        return;

      if (Object.keys(this.getForm().errors).length > 0) {
        var errorEls = Object.keys(this.getForm().errors)
          .map((el) => $(this.$el).find('[name="' + el + '"]'))
          .filter((el) => el.length > 0)
          .map((el) => el[0])
          .sort((e1, e2) => e1.getBoundingClientRect().top - e2.getBoundingClientRect().top);
        
        if (errorEls.length > 0) {
          const firstErrorEl = errorEls[0];
          const fieldType = firstErrorEl.type;
          if (fieldType == 'radio' || fieldType == 'checkbox') {
            return Utility.scrollToElem($(firstErrorEl).parent(), 50);
          }
          if (fieldType == 'hidden') {
            return Utility.scrollToElem($(firstErrorEl).parent(), -200);
          }
          return Utility.scrollToElem($(firstErrorEl), 50);
        }
      }
    },
    bytesToKiloBytes(byteValue) {
      return Math.ceil(byteValue / 1024);
    },
    getMemberData() {
      var memberId = localStorage.getItem('logged_in_member');

      return $.getJSON('/assets/portal/_data/' + memberId + '.json');
    },
    validateField(name, form) {
      form = form || this.getForm();
      form.validateField(name);
    },
    revalidate(value, form) {
      form = form || this.getForm();
      if (typeof value === 'object' && Object.keys(form.errors).length > 0) {
        if ($(value.target).hasClass('invalid')) {
          form.validateField(value.target.name);
        }
      }
    },
    scrollToTop() {
      const { body } = document; // Safari
      const html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
      body.scrollTop = 0;
      html.scrollTop = 0;
    },
    resetSingleFieldValidation(fieldName) {
      const validationField = this.$validator.fields.find({
        name: fieldName
      });
      validationField.reset();
      this.$validator.errors.remove(validationField.name);
    },
    log(logMessages) {
      if (!this.debugMode) {
        return;
      }

      const type = typeof logMessages;
      /* eslint-disable no-console */
      if (type === 'string') {
        return console.log(logMessages);
      }

      return console.log.apply(this, logMessages);
    }
  }
};
</script>
